import SpeedIcon from '@mui/icons-material/Speed';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { lighten } from 'polished';
import { defineMessage, useIntl } from 'react-intl';
import { useTranscriptionInteractionsStore } from '../hooks/useTranscriptionInteractionsStore';

const efficiencyTooltipOnMessage = defineMessage({
  id: 'fragments.transcription.v2.efficiencyTooltipOn',
  defaultMessage: 'Eficiencia por palabra: activado',
});

const efficiencyTooltipOffMessage = defineMessage({
  id: 'fragments.transcription.v2.efficiencyTooltipOff',
  defaultMessage: 'Eficiencia por palabra: desactivado',
});

/**
 * Renders the per-word efficiency toggle action with active/inactive visual state.
 */
export function TranscriptionWordEfficiencyAction() {
  const theme = useTheme();
  const { $t } = useIntl();
  const showWordEfficiency = useTranscriptionInteractionsStore((state) => state.showWordEfficiency);
  const onWordEfficiencyClick = useTranscriptionInteractionsStore(
    (state) => state.onWordEfficiencyClick,
  );

  const efficiencyIconButton = (
    <IconButton
      size="small"
      color={showWordEfficiency ? 'success' : 'secondary'}
      sx={{
        bgcolor: showWordEfficiency ? lighten(0.45, theme.palette.success.light) : undefined,
      }}
      onClick={onWordEfficiencyClick}
    >
      <SpeedIcon fontSize="small" />
    </IconButton>
  );

  return (
    <Tooltip
      placement="top"
      title={showWordEfficiency ? $t(efficiencyTooltipOnMessage) : $t(efficiencyTooltipOffMessage)}
    >
      {efficiencyIconButton}
    </Tooltip>
  );
}
